<template>
  <GmapMap
    :options="options"
    :center="position"
    :zoom="zoom"
    map-type-id="roadmap"
    class="gmap"
  >
    <GmapMarker
      :position="position"
    />
  </GmapMap>
</template>

<script>
export default {
  name: 'AppAddressMap',
  props: {
    address: {
      type: Object,
      required: true,
    },
    zoom: {
      type: Number,
      required: false,
      default: 16,
    },
  },
  computed: {
    options() {
      return {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      };
    },
    position() {
      return { lat: this.address.coordinates.latitude, lng: this.address.coordinates.longitude };
    },
  },
};
</script>

<style scoped lang="scss">
  .gmap {
    height: 100%;
  }
</style>
